export enum PrefectureCode {
  _01_HOKKAIDO = "01",
  _02_AOMORI = "02",
  _03_IWATE = "03",
  _04_MIYAGI = "04",
  _05_AKITA = "05",
  _06_YAMAGATA = "06",
  _07_FUKUSHIMA = "07",
  _08_GUNMA = "08",
  _09_TOCHIGI = "09",
  _10_IBARAKI = "10",
  _11_SAITAMA = "11",
  _12_CHIBA = "12",
  _13_TOKYO = "13",
  _14_KANAGAWA = "14",
  _15_NIGATA = "15",
  _16_TOYAMA = "16",
  _17_ISHIKAWA = "17",
  _18_FUKUI = "18",
  _19_YAMANASHI = "19",
  _20_NAGANO = "20",
  _21_GIFU = "21",
  _22_SHIZUOKA = "22",
  _23_AICHI = "23",
  _24_MIE = "24",
  _25_SHIGA = "25",
  _26_KYOTO = "26",
  _27_OSAKA = "27",
  _28_HYOGO = "28",
  _29_NARA = "29",
  _30_WAKAYAMA = "30",
  _31_TOTTORI = "31",
  _32_SHIMANE = "32",
  _33_OKAYAMA = "33",
  _34_HIROSHIMA = "34",
  _35_YAMAGUCHI = "35",
  _36_TOKUSHIMA = "36",
  _37_KAGAWA = "37",
  _38_EHIME = "38",
  _39_KOCHI = "39",
  _40_FUKUOKA = "40",
  _41_SAGA = "41",
  _42_NAGASAKI = "42",
  _43_KUMAMOTO = "43",
  _44_OITA = "44",
  _45_MIYAZAKI = "45",
  _46_KAGOSHIMA = "46",
  _47_OKINAWA = "47",
}

export function getPrefectureName(value: PrefectureCode | string) {
  switch (value) {
    case PrefectureCode._01_HOKKAIDO:
      return "北海道";
    case PrefectureCode._02_AOMORI:
      return "青森県";
    case PrefectureCode._03_IWATE:
      return "岩手県";
    case PrefectureCode._04_MIYAGI:
      return "宮城県";
    case PrefectureCode._05_AKITA:
      return "秋田県";
    case PrefectureCode._06_YAMAGATA:
      return "山形県";
    case PrefectureCode._07_FUKUSHIMA:
      return "福島県";
    case PrefectureCode._08_GUNMA:
      return "茨城県";
    case PrefectureCode._09_TOCHIGI:
      return "栃木県";
    case PrefectureCode._10_IBARAKI:
      return "群馬県";
    case PrefectureCode._11_SAITAMA:
      return "埼玉県";
    case PrefectureCode._12_CHIBA:
      return "千葉県";
    case PrefectureCode._13_TOKYO:
      return "東京都";
    case PrefectureCode._14_KANAGAWA:
      return "神奈川県";
    case PrefectureCode._15_NIGATA:
      return "新潟県";
    case PrefectureCode._16_TOYAMA:
      return "富山県";
    case PrefectureCode._17_ISHIKAWA:
      return "石川県";
    case PrefectureCode._18_FUKUI:
      return "福井県";
    case PrefectureCode._19_YAMANASHI:
      return "山梨県";
    case PrefectureCode._20_NAGANO:
      return "長野県";
    case PrefectureCode._21_GIFU:
      return "岐阜県";
    case PrefectureCode._22_SHIZUOKA:
      return "静岡県";
    case PrefectureCode._23_AICHI:
      return "愛知県";
    case PrefectureCode._24_MIE:
      return "三重県";
    case PrefectureCode._25_SHIGA:
      return "滋賀県";
    case PrefectureCode._26_KYOTO:
      return "京都府";
    case PrefectureCode._27_OSAKA:
      return "大阪府";
    case PrefectureCode._28_HYOGO:
      return "兵庫県";
    case PrefectureCode._29_NARA:
      return "奈良県";
    case PrefectureCode._30_WAKAYAMA:
      return "和歌山県";
    case PrefectureCode._31_TOTTORI:
      return "鳥取県";
    case PrefectureCode._32_SHIMANE:
      return "島根県";
    case PrefectureCode._33_OKAYAMA:
      return "岡山県";
    case PrefectureCode._34_HIROSHIMA:
      return "広島県";
    case PrefectureCode._35_YAMAGUCHI:
      return "山口県";
    case PrefectureCode._36_TOKUSHIMA:
      return "徳島県";
    case PrefectureCode._37_KAGAWA:
      return "香川県";
    case PrefectureCode._38_EHIME:
      return "愛媛県";
    case PrefectureCode._39_KOCHI:
      return "高知県";
    case PrefectureCode._40_FUKUOKA:
      return "福岡県";
    case PrefectureCode._41_SAGA:
      return "佐賀県";
    case PrefectureCode._42_NAGASAKI:
      return "長崎県";
    case PrefectureCode._43_KUMAMOTO:
      return "熊本県";
    case PrefectureCode._44_OITA:
      return "大分県";
    case PrefectureCode._45_MIYAZAKI:
      return "宮崎県";
    case PrefectureCode._46_KAGOSHIMA:
      return "鹿児島県";
    case PrefectureCode._47_OKINAWA:
      return "沖縄県";
    default:
      return "";
  }
}
